import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "@/store/slices/auth/authSlice";
import generalReducer from "@/store/slices/general/generalSlice";
import companyReducer from "@/store/slices/company/companySlice";
import companiesReducer from "@/store/slices/companies/companiesSlice";
import leadsReducer from "@/store/slices/lead/leadSlice";
import crmLeadReducer from "@/store/slices/lead/crmLeadSlice";
import userReducer from "@/store/slices/users/userSlice";
import reportsReducer from "@/store/slices/report/reportsSlice";
import dashboardReducer from "@/store/slices/dashboard/dashboardSlice";
import staticDashboardReducer from "@/store/slices/staticDashboard/staticDashboardSlice";
import fetchGeneralData from "@/store/slices/fetchGeneralData/fetchGeneralDataOnAuth";
import loadingReducer from "@/store/slices/loading/loadingSlice";
import rolesReducer from "@/store/slices/roles/rolesSlice";
import filtersReducer from "@/store/slices/analytics/analyticSlice";
import navbarReducer from "@/store/slices/sidebar-nav/sidebarNavSlice";
import importReducer from "@/store/slices/import/importSlice";
import profileReducer from "@/store/slices/profile/profileSlice";
import notificationsReducer from "@/store/slices/notifications/notificationsSlice";
import settingsReducer from "@/store/slices/settings/settingsSlice";
import dropdownOptionsReducer from "@/store/slices/general/dropdownOptionsSlice";
import activityReducer from "@/store/slices/activity/activitySlice";
import RequestsReducer from "@/store/slices/requests";
import noteReducer from "@/store/slices/notes/notesSlice";
import voiceReducer from "@/store/slices/voice/voiceSlice";
import CountriesReducer from "@/store/slices/general/countriesSlice";
import SignalRReducer from "@/store/slices/general/signalRHubSlice";
import ListReducer from "@/store/slices/list/listSlice";
import WFReducer from "@/store/slices/workflow/workflowSlice";
import WFRightPanelReducer from "@/store/slices/workflow/rightPanelSlice";
import WFDesignerReducer from "@/store/slices/workflow/designerSlice";
import workflowSnapshotReducer from "@/store/slices/workflow/workflowSnapshotSlice";
import appointmentReducer from "@/store/slices/appointment/appointmentSlice";
import leadScoringReducer from "@/store/slices/score/lead-scoring";
import TourReducer from "@/store/slices/tour/tourSlice";
import emailEditorReducer from "@/store/slices/email-editor/emailEditorSlice";
import tasksReducer from "@/store/slices/tasks/tasksSlice";
import gridStateReducer from "@/store/slices/grid/gridStateSlice";
import routeHistoryReducer from "@/store/slices/route-history/routeHistorySlice";
import featuresReducer from "@/store/slices/features/featuresSlice";
import signupReducer from "@/store/slices/signup/signupSlice";

const appReducers = combineReducers({
  // counter: counterReducer,
  auth: authReducer,
  general: generalReducer,
  company: companyReducer,
  fetchGeneralData: fetchGeneralData,
  loading: loadingReducer,
  companies: companiesReducer,
  // chats: chatsReducer,
  dashboard: dashboardReducer,
  staticDashboard: staticDashboardReducer,
  leads: leadsReducer,
  crmLeads: crmLeadReducer,
  user: userReducer,
  reports: reportsReducer,
  // provisions: provisionReducer,
  roles: rolesReducer,
  features: featuresReducer,
  // scriptLoad: scriptLoadReducer,
  // MessagingChats: MessagingChatsReducer,
  // Suggestions: SuggestionsReducer,
  filters: filtersReducer,
  navbar: navbarReducer,
  // hosts: hostsReducer,
  import: importReducer,
  // widgetEditor: widgetEditorReducer,
  themeProfile: profileReducer,
  // widgetAppearance: widgetAppearanceReducer,
  notifications: notificationsReducer,
  settings: settingsReducer,
  dropdownOptions: dropdownOptionsReducer,
  activity: activityReducer,
  requests: RequestsReducer,
  notes: noteReducer,
  voices: voiceReducer,
  countries: CountriesReducer,
  signalRConnections: SignalRReducer,
  list: ListReducer,
  workflow: WFReducer,
  WFRightPanel: WFRightPanelReducer,
  WFDesigner: WFDesignerReducer,
  workflowSnapshot: workflowSnapshotReducer,
  appointment: appointmentReducer,
  leadScoring: leadScoringReducer,
  tour: TourReducer,
  emailEditor: emailEditorReducer,
  tasks: tasksReducer,
  gridState: gridStateReducer,
  routeHistory: routeHistoryReducer,
  signup: signupReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "auth/logout") {
    return appReducers(undefined, action);
  }
  return appReducers(state, action);
};

export default rootReducer;
